import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const getLeadReportAdmin = async (startDate, endDate) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/dashboard/api/lead-report/lead_report_admin/`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
        },
        ...getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch lead report admin"
    );
  }
};
